import { render, staticRenderFns } from "./CreatorPostGifts.vue?vue&type=template&id=899df966&"
import script from "./CreatorPostGifts.vue?vue&type=script&lang=js&"
export * from "./CreatorPostGifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports